import React from "react";
import type { TicketStatus } from "../../types/supportTicket";

interface Props {
  status: TicketStatus;
}

const TicketStatusBadge: React.FC<Props> = ({ status }) => {
  return (
    <span
      className={`ticket-status-badge ${status.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {status}
    </span>
  );
};

export default TicketStatusBadge;
